<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage"></div>
    <div class="panel">
      <div class="body-panel-login">
        <b-form>
          <img class="img-fluid mx-auto d-block" src="@/assets/logo-indecx.png" alt="" />
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <font-awesome-icon :icon="['fas', 'user']" />
              </b-input-group-text>
              <b-input id="email" v-model="form.email" type="email" required :placeholder="$t('login.form.emailInput')"
                autofocus></b-input>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <font-awesome-icon :icon="['fas', 'key']" />
              </b-input-group-text>
              <b-input id="password" v-model="form.password" type="password" required
                :placeholder="$t('login.form.passwordInput')" @keyup.enter="validateData()" autofocus
                autocomplete="off"></b-input>
            </b-input-group>
          </b-form-group>
          
          <b-form-group>
            <b-button type="button" @click="validateData()" class="btn-block" variant="primary" :disabled="loading">{{
              $t('login.form.submitButton') }}</b-button>
          </b-form-group>
          <router-link class="forgotPassword" to="/forgot-password">{{
            $t('login.form.forgotPasswordLabel')
          }}</router-link>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import backgroundMercedes0 from '../../../../assets/background00-mercedes-2023.jpg';
import backgroundMercedes1 from '../../../../assets/background01-mercedes-2023.jpg';
import backgroundMercedes2 from '../../../../assets/background02-mercedes-2023.jpg';
import backgroundBoticario1 from '../../../../assets/background-boticario.jpeg';
import api from '../../../../services/api';

export default {
  name: 'Login',

  data: () => ({
    show: true,
    loading: false,
    companyId: null,
    form: {
      email: null,
      password: null,
    },
    selectedCompany: null,
    companyOptions: [],
    companyList: [],
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
  }),

  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('companies', ['company']),
  },

  methods: {
    ...mapActions('authentication', ['login']),
    ...mapActions('companies', ['getCompany']),

    validateData() {
      if (!this.loading) {
        this.loading = true;

        if (!this.form.email) {
          this.makeToast(
            this.$t('login.tooltips.emailValidation.description'),
            this.$t('login.tooltips.emailValidation.title'),
          );
        }

        if (!this.form.password) {
          this.makeToast(
            this.$t('login.tooltips.passwordValidation.description'),
            this.$t('login.tooltips.passwordValidation.title'),
          );
        }

        this.login({
          email: this.form.email,
          password: this.form.password,
          companyId: this.companyId,
          selectedCompany: this.selectedCompany,
        })
          .then(async (res) => {
            this.loading = false;

            this.companyList = res.companyList ? res.companyList : [];
            this.companyOptions = [];
            if (this.companyList && this.companyList.length > 1) {
              for (let i = 0; i < this.companyList.length; i += 1) {
                this.companyOptions.push({
                  text: this.companyList[i].companyName,
                  value: this.companyList[i].companyId,
                });
              }
            }

            if (!res.auth) {
              this.makeToast(
                this.$t('login.tooltips.loginValidation.description'),
                this.$t('login.tooltips.loginValidation.title'),
              );
            } else {
              await this.getCompany({
                id: res.companyId,
                token: res.token,
              });

              if (this.company.SSO) {
                this.$bvToast.toast(
                  'Esta organização utiliza autenticação via SSO. Por favor verifique o endereço correto para login',
                  {
                    title: 'Atenção',
                    autoHideDelay: 10000,
                    appendToast: false,
                    variant: 'danger',
                  },
                );
                this.logout(res.token);
                this.loading = false;
                return;
              }

              // verify enable two factor
              const enableTwoFactor = this.company.enableTwoFactor;
              if (this.company.alertPopup) {
                localStorage.setItem('alertPopup', 'true');
              }
              if (enableTwoFactor) {
                // generate two factor code
                await api.post('/two-factor', {
                  email: this.user.email,
                });

                this.loading = false;

                this.$router.push({
                  name: 'Two Factor',
                  params: { email: this.user.email, companyId: res.companyId },
                });
              } else {
                this.loading = false;

                if (this.user.permissions.permissions.dashboard.menu) {
                  if (
                    this.companyList.length > 1
                  ) {
                    this.$router.push(`/list-companies/${this.user._id}`);
                  } else if (this.company.homePageIsNotDashboard) {
                    this.$router.push(`/powerbi`);
                  } else {
                    this.$router.push(`/dashboard/${res.companyId}`);
                  }
                }

                if (!this.user.permissions.permissions.dashboard.menu) {
                  this.$router.push(`/answers`);
                }
              }
            }
          })
          .catch((err) => {
            const code = parseInt(err.message.replace(/[^0-9]/g, ''), 10);

            this.loading = false;

            switch (code) {
              case 400:
                this.makeToast(
                  this.$t('login.tooltips.loginValidation.description'),
                  this.$t('login.tooltips.loginValidation.title'),
                );
                break;
              case 401:
                this.makeToast(
                  this.$t('login.tooltips.loginValidation.description'),
                  this.$t('login.tooltips.loginValidation.title'),
                );
                break;
              case 403:
                this.makeToast(
                  this.$t('login.tooltips.loginValidation.description'),
                  this.$t('login.tooltips.loginValidation.title'),
                );
                break;
              default:
                this.makeToast(
                  this.$t('login.tooltips.genericError.description'),
                  this.$t('login.tooltips.genericError.title'),
                );
            }
          });
      }
    },

    makeToast(message, title, append = false) {
      this.toastCount += 1;

      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },

  created() {
    let imgs = [];

    if (this.$route.name === 'Login Mercerdes Benz') {
      this.companyId = '5e18ccd0dc36a60022491bdf';
      // imgs = [
      //   backgroundMercedes1,
      //   backgroundMercedes2,
      //   backgroundMercedes3,
      //   backgroundMercedes4,
      //   backgroundMercedes5,
      //   backgroundMercedes6,
      // ];
      imgs = [
        backgroundMercedes0,
        backgroundMercedes1,
        backgroundMercedes2,
      ];
    } else if (this.$route.name === 'Login Boticario') {
      imgs = [backgroundBoticario1];
    }

    this.bgPage.background = `url('${imgs[Math.floor(Math.random() * imgs.length)]
      }')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.forgotPassword {
  display: block;
  text-align: center;
}

.wrapper {
  @extend %center;

  .bg-page {
    position: fixed;
    top: 0;
    left: 0;
    transform: scale(1);
    opacity: 0.6;
    z-index: -1;
    transition: all 0.2s linear;
    animation: zoomOut 0.4s;
  }

  @keyframes zoomOut {
    from {
      transform: scale(1.3);
      opacity: 0;
    }

    to {
      transform: scale(1);
      opacity: 0.6;
    }
  }

  .panel {
    width: 90%;
    max-width: 420px;

    border-radius: 5px;
    display: flex;
    flex-direction: column;
    @include bg-color(rgba(255, 255, 255, 0.8));

    @media screen and (min-width: 576px) {
      width: 100%;
    }

    .body-panel-login {
      // @include bg-color($white);
      @extend %double-padding-left,
      %double-padding-right,
      %double-padding-top,
      %double-padding-bottom;

      form {
        @extend %double-padding-top, %double-padding-bottom;

        .img-fluid {
          width: 50%;
          margin-bottom: 30px;
        }

        .input-group-text {
          border: none;
          @include bg-color($white);
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-right: none;
        }

        .form-control {
          box-shadow: none;
          border: none;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          @include bg-color($white);
          text-indent: 0;
          padding: 0;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-left: none;
        }
      }

      button {
        border-radius: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/login-company/index.vue